import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Popup } from '../../utils/popups';
import { DeviceDropdown } from '../DeviceDropdown';
import { RightCaret as PrestyledRightCaret, ReportIcon } from '../Icon';
import { PopupButton } from '../PopupButton';
import { about, help, tos } from './InfoPopup';
import { UtilityPopup } from './UtilityPopup';
export function SettingsPopup({ reject: rejectProp, resolve, ...props }) {
    const [isAudioDropdownOpen, setIsAudioDropdownOpen] = useState(false);
    const [isVideoDropdownOpen, setIsVideoDropdownOpen] = useState(false);
    const reject = useCallback((reason) => {
        if (isAudioDropdownOpen || isVideoDropdownOpen) {
            return;
        }
        rejectProp(reason);
    }, [rejectProp, isAudioDropdownOpen, isVideoDropdownOpen]);
    return (_jsxs(UtilityPopup, { reject: reject, ...props, children: [_jsxs(Inputs, { children: [_jsx(DeviceDropdown, { kind: "audio", isOpen: isAudioDropdownOpen, setIsOpen: setIsAudioDropdownOpen }), _jsx(DeviceDropdown, { kind: "video", isOpen: isVideoDropdownOpen, setIsOpen: setIsVideoDropdownOpen })] }), _jsxs(Links, { children: [_jsx(LinkButton, { type: "button", onClick: () => {
                            help();
                            resolve();
                        }, children: "Help" }), _jsx(LinkButton, { type: "button", onClick: () => {
                            about();
                            resolve();
                        }, children: "About" }), _jsx(LinkButton, { type: "button", onClick: () => {
                            tos();
                            resolve();
                        }, children: "Terms of service" })] }), _jsx(Links, { children: _jsx(PopupButton, { asLink: true, href: "https://forms.gle/a1rXpngeEKx53muU6", target: "_blank", rel: "noopener noreferrer", prependComponent: _jsx(ReportIcon, {}), appendComponent: _jsx(RightCaret, {}), children: "Report" }) })] }));
}
function LinkButton({ children, ...props }) {
    return (_jsxs(LinkButtonRoot, { ...props, children: [_jsx(LinkButtonLabel, { children: children }), _jsx(RightCaret, {})] }));
}
const LinkButtonLabel = styled.div `
    flex: 1;
    font-size: 1rem;
    font-weight: 500;
    min-width: 0;
`;
const LinkButtonRoot = styled.button `
    align-items: center;
    background: rgba(53, 54, 49, 0.55);
    appearance: none;
    border: 0;
    padding: 1rem;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    color: #ffffff;
    min-height: 3.375rem;
    transition: 200ms background-color;

    & + & {
        margin-top: 1px;
    }

    &:hover {
        background: rgba(53, 54, 49, 0.65);
        transition-duration: 50ms;
    }
`;
export const Inputs = styled.div `
    * + & {
        margin-top: 1.5rem;
    }

    & > * + * {
        margin-top: 0.5rem;
    }
`;
const Links = styled.div `
    margin-top: 1.25rem;
    border-radius: 0.875rem;
    overflow: hidden;
`;
const RightCaret = styled(PrestyledRightCaret) `
    opacity: 0.6;
`;
export const settingsPopup = Popup.create(SettingsPopup);
